import React from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/fit';
import { sendBiEventWithPosition } from '../../../../shared/utils/sendBiEventWithPosition';
import { EVENT_TYPES } from '../../../../service/bigquery';
import { GET_STARTED_CTA_POSITIONS } from '../../../../shared/constants';
import { INNER_CLASSES, getStartUrlWithSource } from '../constants';
import './style.scss';

const GetStartedBanner = ({ integration }) => (
    <section className={classnames('get-starter-banner', INNER_CLASSES)}>
        <h2>
            <I18n k="makers_experience_perseus.buyer_landing_page.get_started.cta_text" />
        </h2>
        <Button
            color="blue"
            href={getStartUrlWithSource(integration)}
            onClick={() =>
                sendBiEventWithPosition(
                    GET_STARTED_CTA_POSITIONS.MIDDLE,
                    EVENT_TYPES.GET_STARTED_BUYER_CLICKED
                )
            }
        >
            <I18n k="makers_experience_perseus.general.start_now" />
        </Button>
    </section>
);

GetStartedBanner.propTypes = {
    integration: string,
};

export default GetStartedBanner;
